<template>
  <section class="mobility">
    <booking-vehicle
      :is-zoe="false"
      v-if="!showHeader"
    />
    <zoe-offers />
  </section>
</template>
<script>
import BookingVehicle from '../Booking/BookingVehicle'
import ZoeOffers from './ZoeOffers'

export default {
  name: 'ZoeLayout',
  components: {
    BookingVehicle,
    ZoeOffers,
  },
  computed: {
    showHeader() {
      return this.$store.state.stepping.header
    },
  },
}
</script>

<style lang="scss" scoped>
section ::v-deep .toto {
  color: red;
}
</style>
